/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { product_category } from '../models/product_category';
import type { vw_product_category } from '../models/vw_product_category';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductCategoryService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postProductCategoryDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/product_category/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of product categories
     * @returns vw_product_category A list of product_category
     * @throws ApiError
     */
    public getProductCategories(): CancelablePromise<Array<vw_product_category>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/product_categories',
        });
    }

    /**
     * Get product_category by id
     * @returns vw_product_category The product_category data
     * @throws ApiError
     */
    public getProductCategory({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_product_category> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/product_category/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `ProductCategory not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a product_category by id
     * @returns any ProductCategory deleted successfully
     * @throws ApiError
     */
    public deleteProductCategory({
        id,
    }: {
        /**
         * The product_category id
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/product_category/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `ProductCategory not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new ProductCategory
     * @returns any ProductCategory created successfully
     * @throws ApiError
     */
    public postProductCategory({
        requestBody,
    }: {
        requestBody: product_category,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/product_category',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing ProductCategory
     * @returns any ProductCategory updated successfully
     * @throws ApiError
     */
    public putProductCategory({
        requestBody,
    }: {
        requestBody: product_category,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/product_category',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `ProductCategory not found`,
                500: `Internal server error`,
            },
        });
    }

}
